/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface IBreadcrumb {
  text: string;
  link: string;
}

interface IAppState {
  isMobile: boolean;
  isTablet: boolean;
  isMobileMenuOpened: boolean;
  mobileBreadcrumbs: IBreadcrumb[];
}

const initialState = {
  isMobile: false,
  isTablet: false,
  isMobileMenuOpened: false,
  mobileBreadcrumbs: [],
} as IAppState;

const modalsSlice = createSlice({
  name: 'appState',
  initialState,
  reducers: {
    setMobile(state, action: PayloadAction<boolean>) {
      state.isMobile = action.payload;
    },
    setTablet(state, action: PayloadAction<boolean>) {
      state.isTablet = action.payload;
    },
    toggleMobileMenu(state, action: PayloadAction<boolean>) {
      state.isMobileMenuOpened = action.payload;
    },
    setMobileBreadcrumbs(state, action: PayloadAction<IBreadcrumb[]>) {
      state.mobileBreadcrumbs = action.payload;
    },
  },
});

export const { setMobile, setTablet, toggleMobileMenu, setMobileBreadcrumbs } = modalsSlice.actions;

export default modalsSlice.reducer;
